import { AlpineStorage } from "alpinejs";
import Cookies from "js-cookie";

export const CookieStorage: AlpineStorage = {
    getItem: (key) => Cookies.get(key) || null,
    setItem: (key, value) => Cookies.set(key, value, { expires: 7 }),
};
